<template>
    <ion-page>
        <standard-header :title="title" align="middle"/>
        <ion-content>
            <skeleton :rows="4" v-if="item === null"></skeleton>
            <pull-down-refresh :callback="refresh"/>

            <ion-list v-if="item">
                <ion-item >
                    <ion-label>
                        <h2>{{ item.name }}</h2>
                        <p>{{ item.item_number }}</p>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-button size="medium" class="product-card" expand="fill" fill="outline" color="dark" @click="$refs['product-card'].open()">Product Card</ion-button>
                    <product-card-modal ref="product-card" :item="item"/>
                </ion-item>
                <ion-item>
                    <ion-label>Temporary Locations</ion-label>
                </ion-item>
                <ion-item lines="none" v-for="location in locations" :key="location.id" button detail @click="move(item, location)">
                    <ion-avatar slot="start" class="ion-justify-content-center ion-align-items-center">
                        {{ location.pivot.qty_total + location.pivot.b_qty_total }}
                    </ion-avatar>
                    <ion-label class="ion-text-wrap">
                        <h2>
                            {{ location.code }}
                            <ion-badge v-show="location.pivot.qty_reserved > 0" color="danger" size="small">
                                Rsvd (A) {{ location.pivot.qty_reserved }}
                            </ion-badge>
                            <ion-badge v-show="location.pivot.b_qty_reserved > 0" color="danger" size="small">
                                Rsvd (B) {{ location.pivot.b_qty_reserved }}
                            </ion-badge>
                        </h2>
                        <p>
                            <span v-show="location.pivot.qty_total">Ax{{ location.pivot.qty_total }} </span>
                            <span v-show="location.pivot.qty_total > 0 && location.pivot.b_qty_total > 0">&nbsp;</span>
                            <span v-show="location.pivot.b_qty_total">Bx{{ location.pivot.b_qty_total }} </span>
                        </p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>
</template>

<script>
import StandardHeader from "@/components/StandardHeader";
import {
    IonAvatar,
    IonButton,
    IonContent,
    IonItem,
    IonLabel,
    IonList,
    IonBadge,
    IonPage, modalController,
} from "@ionic/vue";
import PullDownRefresh from "@/components/PullDownRefresh";
import Skeleton from "@/components/Skeleton";
import ProductCardModal from "@/components/Modals/ProductCardModal";
import MoveModal from "@/views/modules/warehouse/stack/MoveModal";
export default {
    name: "Stack",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        IonButton, IonAvatar,
        ProductCardModal,
        Skeleton,
        PullDownRefresh,
        StandardHeader,
        IonContent, IonItem, IonLabel, IonList, IonPage, IonBadge
    },
    computed: {
        params() {
            return this.$route.params;
        },
        locations() {
            if (this.item) {
                return this.item.locations;
            }
            return [];
        },
        title() {
            if (this.item && this.item.item_number) {
                return 'Stack ' + this.item.item_number;
            }
            return '';
        }
    },
    methods: {
        ionViewDidEnter() {
            this.refresh();
        },
        move(item, location) {
            modalController.create({
                component: MoveModal,
                componentProps: {
                    item: item,
                    source: location,
                    initMode: 'stack',
                    confirmLabel: 'Stack Item'
                }
            }).then(modal => {
                modal.present();
                modal.onDidDismiss()
                    .then(response => {
                        if (response.data) {
                            this.refresh();
                        }
                    });
            });
        },
        refresh(event) {
            this.item = null;
            this.$http.get(`/api/stack/items/${this.params.item}`, {
                params: {all: true, include: 'locations,locations.pivot,skus,image_urls'}
            }).then(response => {
                this.item = response.data;
                console.log(response.data);
            }).catch(error => {
                this.$validationAlert(error);
                this.item = null;
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        },
    },
    data() {
        return {
            data: null,
            item: null
        }
    }
}
</script>

<style scoped>
    ion-badge {
        position: relative;
        top: 3px;
    }
    ion-avatar {
        border-radius: 50%;
        background-color: var(--ion-color-primary);
        color: var(--ion-color-primary-contrast);
        font-weight: bold;
        display:flex;
    }
    .product-card {
        flex: 1
    }
</style>
